<loren-page-content>
  <div class="loren-asset-details-header">
    <div class="loren-asset-details-breadcrumb">
      <a routerLink [href]="routes.DASHBOARD">{{
        "asset_details.dashboard" | transloco
      }}</a>
      /
      <a routerLink [href]="routes.ASSETS_LIST">{{
        "asset_details.assets" | transloco
      }}</a>
      /
      {{ asset()?.name }}
    </div>
    <div
      *lorenShowForPrivileges="[writeRole]"
      class="loren-asset-details-actions">
      <button matButton="filled" (click)="editAsset()">
        <mat-icon>edit</mat-icon>
        {{ "asset_details.edit" | transloco }}
      </button>
      <button matButton="filled" (click)="deleteAsset()" class="btn-error">
        <mat-icon>delete</mat-icon>
        {{ "asset_details.delete" | transloco }}
      </button>
    </div>
  </div>
  <div class="loren-asset-details-main">
    <div class="loren-asset-details-image">
      @if(asset()?.image) {
      <img [src]="$safeNavigationMigration(asset()?.image) | lorenImage | async" alt="Asset image" />
      } @else {
      <div class="loren-asset-details-image--none">
        <mat-icon>image_not_supported</mat-icon>
      </div>
      }
    </div>
    <div class="loren-asset-details-content">
      <div class="loren-asset-details-title">
        {{ asset()?.name }}
      </div>
      <div class="loren-asset-details-item--title">
        {{ "asset_details.type" | transloco }}:
      </div>
      <div class="loren-asset-details-item--value">
        {{ assetType()?.label }}
      </div>
      <div class="loren-asset-details-item--title">
        {{ "asset_details.group" | transloco }}:
      </div>
      <div class="loren-asset-details-item--value">
        <a routerLink [href]="routes.GROUPS">{{ groups().join(", ") }}</a>
      </div>
      @if(location()) {
      <div class="loren-asset-details-item--title">
        {{ "asset_details.coordinates" | transloco }}:
      </div>
      <div class="loren-asset-details-item--value">
        {{ location() }}
      </div>
      }
      <div class="loren-asset-details-item--title">
        {{ "asset_details.description" | transloco }}:
      </div>
      <div class="loren-asset-details-item--value">
        {{ asset().description || ("asset_details.no_info" | transloco) }}
      </div>
      @if(properties()) { @for(prop of properties(); track prop) {
      <div class="loren-asset-details-item--title">
        {{ "properties." + prop.name | transloco }}
      </div>
      <div class="loren-asset-details-item--value">
        {{ prop.value || ("asset_details.no_info" | transloco) }}
      </div>
      } }
    </div>
  </div>
</loren-page-content>
